import {
  EXPERIMENT_VARIATION,
  HEADER_SEARCH_BOX_CLICK,
  HEADER_SEARCH_BUTTON_CLICK,
  HEADER_SEARCH_ICON_CLICK,
  SEARCH_BAR_INTERACTION,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { bindTrackingEvents } from 'shared/experiments/utils/tracking'

let before = Date.now()

const searchBoxInputs = Array.from(
  document.querySelectorAll(
    '.m-FormControlWithFloatingLabel__formControl[type="search"],' +
      '#h-SearchBox__mobile .m-FormControlWithFloatingLabel__label div'
  )
)
const placeholderText =
  searchBoxInputs[0]?.textContent ||
  searchBoxInputs[0]?.getAttribute('placeholder')
const placeholderWords = placeholderText?.split(' ')
const initialText = placeholderWords?.slice(0, 2).join(' ') || ''
const displayedText = initialText + ' '
let lettersCount = 0
let displayText = displayedText
let eraseLetters = false

export const animateSearchInput = async () => {
  const interval = 20
  const now = Date.now()

  if (now - before >= interval) {
    const hiddenText =
      placeholderWords?.slice(2, placeholderWords.length).join(' ') || ''

    if (lettersCount === hiddenText?.length) {
      await new Promise(resolve => setTimeout(resolve, 500))
    }
    before = now

    if (!eraseLetters) {
      if (lettersCount < hiddenText?.length) {
        displayText = displayText + hiddenText?.charAt(lettersCount)
        lettersCount = lettersCount + 1
      } else {
        eraseLetters = true
      }
    } else {
      lettersCount = lettersCount - 1
      displayText = displayedText + hiddenText?.substring(0, lettersCount)

      if (lettersCount <= 0) {
        eraseLetters = false
      }
    }

    if (searchBoxInputs) {
      searchBoxInputs.forEach(searchBoxInput => {
        if (searchBoxInput.getAttribute('placeholder')) {
          searchBoxInput.setAttribute('placeholder', displayText)
        } else {
          searchBoxInput.innerHTML = displayText
        }
      })
    }
  }
  window.requestAnimationFrame(animateSearchInput)
}

export default async () => {
  const { isEnabled, variant } = getExperimentOnClient(SEARCH_BAR_INTERACTION)

  if (!isEnabled) return

  await activateExperiment(SEARCH_BAR_INTERACTION)

  bindTrackingEvents([
    {
      selector: '.o-HeaderLarge #h-SearchBox [name="query-button"]',
      event: 'click',
      trackingEvent: HEADER_SEARCH_BUTTON_CLICK,
    },
    {
      selector: '.o-HeaderLarge #h-SearchBox #h-SearchBox__input',
      event: 'click',
      trackingEvent: HEADER_SEARCH_BOX_CLICK,
    },
    {
      selector: '.o-HeaderSmall .o-HeaderSmall__dummyInput',
      event: 'click',
      trackingEvent: HEADER_SEARCH_BOX_CLICK,
    },
    {
      selector: '.o-HeaderSmall [name="searchbox-mobile-search-icon"]',
      event: 'click',
      trackingEvent: HEADER_SEARCH_ICON_CLICK,
    },
  ])

  if (
    EXPERIMENT_VARIATION.V2 === variant ||
    EXPERIMENT_VARIATION.V3 === variant
  ) {
    void animateSearchInput()
  }
}
